import { z } from 'zod'

export const carryForwardStatusSchema = z.enum([
  'draft',
  'submitted',
  'pending_hr_review',
  'pending_director_review',
  'approved',
  'rejected',
  'expired',
  'consumed',
])
export type CarryForwardStatus = z.infer<typeof carryForwardStatusSchema>

export const carryForwardCorroborationSchema = z.enum([
  'yes',
  'partially',
  'no',
  'cant_say',
])
export type CarryForwardCorroboration = z.infer<
  typeof carryForwardCorroborationSchema
>

export const carryForwardRequestSchema = z.object({
  id: z.guid(),
  employeeId: z.guid(),
  leaveTypeId: z.string(),
  yearFrom: z.number().int(),
  yearTo: z.number().int(),
  daysRequested: z.string(),
  daysApproved: z.string().nullable(),
  status: carryForwardStatusSchema,
  reason: z.string(),
  evidenceUrl: z.string().nullable(),
  managerCorroborationRequested: z.boolean(),
  managerCorroborationAnswer: carryForwardCorroborationSchema.nullable(),
  managerCorroborationNote: z.string().nullable(),
  hrRecommendationNote: z.string().nullable(),
  hrRecommendedAt: z.string().nullable(),
  hrRecommendedBy: z.string().nullable(),
  submittedAt: z.string().nullable(),
  decidedAt: z.string().nullable(),
  decidedByRole: z.string().nullable(),
  decisionNote: z.string().nullable(),
  expiresOn: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
})
export type CarryForwardRequest = z.infer<typeof carryForwardRequestSchema>

export interface CarryForwardRecommendation {
  note: string
}

export interface CarryForwardDraftCreate {
  leaveTypeId?: string
  daysRequested: number
  reason: string
  evidenceUrl?: string | null
}

export interface CarryForwardDraftUpdate {
  daysRequested?: number
  reason?: string
  evidenceUrl?: string | null
}

export interface CarryForwardDecision {
  daysApproved?: number
  decisionNote?: string
}

export interface CarryForwardApprovalRate {
  total: number
  approved: number
  rate: number
  ceiling: number
  exceeded: boolean
}

export interface CarryForwardTelemetry {
  totalRequests: number
  approved: number
  rejected: number
  autoRejected: number
  pending: number
  medianTimeToDecisionHours: number | null
  expiryClawbackCount: number
  reasonLengthAvg: number | null
  repeatRequesterCount: number
}
